import React from "react";
import ImageAtom from "@components/atoms/Image";
import Text from "@components/atoms/Text";
import { TitleWithIconProps } from "./TitleWithIcon.types";
import styles from "./TitleWithIcon.module.scss";

const TitleWithIcon = ({
  title,
  iconSrc,
  alt,
  iconClassName = "",
}: TitleWithIconProps) => {
  return (
    <Text level="h1" className={styles.title}>
      {title}{" "}
      <span className={`${styles.iconWrapper} ${iconClassName}`}>
        <ImageAtom
          src={iconSrc}
          alt={alt}
          width={32}
          height={32}
          className={styles.iconImage}
        />
      </span>
    </Text>
  );
};

export default TitleWithIcon;
export type { TitleWithIconProps };
